// please keep this sorted alphabetically
import Checkbox from "./checkbox/Checkbox";
import configured from "./configured/";
import DateInput from "./date-input/DateInput";
import DatePicker from "./date-picker/DatePicker";
import EmailVerifyInput from "./email-verify-input/EmailVerifyInput";
import Form from "./form/Form";
import GoogleAddressInput from "./google-address-input/GoogleAddressInput";
import hocs from "./hocs/";
import InputField from "./input-field/InputField";
import InputFieldDeprecated from "./input-field/InputFieldDeprecated";
import MoneyInput, { cleanValue } from "./money-input/MoneyInput";
import PasswordInput from "./password-input/PasswordInput";
import Radio from "./radio/Radio";
import Recaptcha from "./recaptcha/Recaptcha";
import RlConditionalLabel from "./rl-conditional-label/RlConditionalLabel";
import Select from "./select/Select";
import TextArea from "./textarea/TextArea";

// please keep this sorted alphabetically
const components = {
  Checkbox,
  configured,
  DateInput,
  DatePicker,
  EmailVerifyInput,
  Form,
  GoogleAddressInput,
  hocs,
  InputField,
  InputFieldDeprecated,
  MoneyInput: {
    MoneyInput,
    cleanValue
  },
  PasswordInput,
  Radio,
  Recaptcha,
  RlConditionalLabel,
  Select,
  SsnInput: configured.SocialSecurity,
  TextArea
};

export default components;
